import { UserProfileModel } from 'mvppoker-portal-common/api'
import React from 'react'
import './UserProfileModal.scss'

export interface UserProfileModalViewProps
{
	userProfile: UserProfileModel,
}

export const UserProfileModalView : React.FC<UserProfileModalViewProps> = ({ userProfile }) =>
{
	return (
		<>
			<span className='modal-title-l'>USER PROFILE</span>
			<img id='user-avatar' className='avatar  big' src={userProfile.info.avatar} alt='avatar'/>
			<p className='big'>{userProfile.info.name}</p>
			<p>HANDS PLAYED: {userProfile.statistics.global.handsPlayed}</p>
			<p>HANDS WON: {userProfile.statistics.global.handsWon}</p>
			<p>BIGGEST POT WON: ${userProfile.statistics.global.highestHandWonAmount}</p>
			<p>FRIENDS: {userProfile.friends.friends.length}</p>
		</>
	)
}
